var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99951 19.6884V70.3131C4.99951 74.2134 7.16196 78.0187 9.64817 80.5079C12.1735 83.0378 16.0768 85 19.9996 85H69.9994C72.186 85 74.5396 84.2952 76.0425 83.5438C81.0827 81.0245 84.9995 75.9828 84.9995 69.9999V20.0001C84.9995 16.0396 83.0554 12.1921 80.5075 9.64866C78.0273 7.17148 74.1993 5 70.3126 5H19.6879C12.3573 5 5.00102 12.302 5.00102 19.6869L4.99951 19.6884ZM25.6135 64.5727L31.1356 64.5667L41.0925 39.3176C41.3214 38.7197 41.478 38.1294 41.8997 37.6204L39.4029 51.1779C39.0023 53.2515 36.879 63.3123 37.0191 64.5727L42.5412 64.5682C43.514 62.6015 50.5073 41.8008 52.4032 36.6807L52.879 35.6778C52.5282 40.1247 51.3205 45.6573 50.6006 50.2051C50.2212 52.604 48.2454 63.0337 48.4261 64.5727L53.9467 64.5697L64.4819 32.0336C63.4323 31.5126 62.1477 30.6286 61.0756 29.9419C59.8784 29.1754 58.8318 28.546 57.5563 27.7614C53.254 25.1186 54.8623 25.4077 48.3614 25.5749L52.8881 33.6148C51.2271 32.6992 43.5606 26.1742 42.8453 25.7721C41.8334 25.2044 38.3623 25.5553 36.9363 25.5628L41.8379 35.2351C41.2853 35.0303 41.5744 35.196 41.2039 34.8872C41.1648 34.8541 40.8817 34.577 40.7943 34.4942L31.6672 25.9468C30.5784 25.084 27.2369 25.5613 25.5096 25.5613C26.1075 27.5084 31.0724 37.7108 31.0904 38.7242C31.1145 40.0705 25.4102 62.6166 25.609 64.5727H25.6135Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMira);
export default __webpack_public_path__ + "static/media/mira.220f310dac26904c323f02e9b5abefd8.svg";
export { ForwardRef as ReactComponent };